<div class="p-3">
  <form [formGroup]="professorForm" (ngSubmit)="onSubmit()">
    <!-- Affectations : un prof peut enseigner plusieurs matières / niveaux -->
    <div class="mb-3">
      <label class="form-label">
        {{ 'ADMIN.ASSIGNMENTS' | translate }} <span class="text-danger">*</span>
      </label>
      <div class="row g-2 align-items-end">
        <div class="col-md-5">
          <app-custom-select
            [options]="pathOptions"
            [allowAdd]="false"
            [inputId]="'learningPathId'"
            [placeholderText]="'ADMIN.SELECT_PATH' | translate"
            [triggerClass]="'select-trigger form-select'"
            (selectionChange)="onPathChange()"
            formControlName="learningPathId">
          </app-custom-select>
        </div>
        <div class="col-md-5">
          <app-custom-select
            [options]="subjectOptions"
            [allowAdd]="false"
            [inputId]="'subjectId'"
            [placeholderText]="'ADMIN.SELECT_SUBJECT' | translate"
            [triggerClass]="'select-trigger form-select'"
            [disabled]="!professorForm.get('learningPathId')?.value"
            formControlName="subjectId">
          </app-custom-select>
        </div>
        <div class="col-md-2">
          <button type="button" class="btn btn-outline-primary w-100"
                  [disabled]="!professorForm.get('subjectId')?.value"
                  (click)="addAssignment()"
                  [title]="'BUTTONS.ADD' | translate">
            <i class="fa-solid fa-plus"></i>
          </button>
        </div>
      </div>

      <!-- Matières retenues -->
      <div class="d-flex flex-wrap gap-2 mt-2" *ngIf="assignments.length > 0">
        <span class="badge bg-light text-dark border d-inline-flex align-items-center gap-2 py-2 px-3"
              *ngFor="let a of assignments">
          <span>{{ a.pathTitle }} · <strong>{{ a.subjectName }}</strong></span>
          <button type="button" class="btn-close" style="font-size:.55rem"
                  (click)="removeAssignment(a.subjectId)"
                  [attr.aria-label]="'BUTTONS.DELETE' | translate"></button>
        </span>
      </div>

      <div class="text-muted small mt-2" *ngIf="isLoadingAssignments">
        <i class="fa-solid fa-spinner fa-spin me-1"></i>
        {{ 'ADMIN.LOADING_ASSIGNMENTS' | translate }}
      </div>

      <div class="text-danger small mt-2" *ngIf="assignmentsLoadFailed">
        {{ 'ADMIN.ERROR_LOADING_ASSIGNMENTS' | translate }}
      </div>

      <div class="text-danger small mt-2" *ngIf="assignmentError">
        {{ 'ADMIN.ASSIGNMENTS_REQUIRED' | translate }}
      </div>
    </div>

    <div class="row">
      <!-- First Name -->
      <div class="col-md-6 mb-3">
        <label for="firstName" class="form-label">
          {{ 'DATA_TABLE.FIRST_NAME' | translate }}
          <span class="text-danger">*</span>
        </label>
        <input
          type="text"
          class="form-control"
          id="firstName"
          formControlName="firstName"
          [class.is-invalid]="isFieldInvalid('firstName')"
          [placeholder]="'DATA_TABLE.FIRST_NAME' | translate"
        />
        <div class="invalid-feedback" *ngIf="isFieldInvalid('firstName')">
          {{ getErrorMessage('firstName') }}
        </div>
      </div>

      <!-- Last Name -->
      <div class="col-md-6 mb-3">
        <label for="lastName" class="form-label">
          {{ 'DATA_TABLE.LAST_NAME' | translate }}
          <span class="text-danger">*</span>
        </label>
        <input
          type="text"
          class="form-control"
          id="lastName"
          formControlName="lastName"
          [class.is-invalid]="isFieldInvalid('lastName')"
          [placeholder]="'DATA_TABLE.LAST_NAME' | translate"
        />
        <div class="invalid-feedback" *ngIf="isFieldInvalid('lastName')">
          {{ getErrorMessage('lastName') }}
        </div>
      </div>
    </div>

    <div class="row">
      <!-- Email -->
      <div class="col-md-6 mb-3">
        <label for="email" class="form-label">
          {{ 'DATA_TABLE.EMAIL' | translate }}
          <span class="text-danger">*</span>
        </label>
        <input
          type="email"
          class="form-control"
          id="email"
          formControlName="email"
          [class.is-invalid]="isFieldInvalid('email')"
          [placeholder]="'DATA_TABLE.EMAIL' | translate"
        />
        <div class="invalid-feedback" *ngIf="isFieldInvalid('email')">
          {{ getErrorMessage('email') }}
        </div>
      </div>

      <!-- Telephone -->
      <!--
      <div class="col-md-6 mb-3">
        <label for="tel" class="form-label">
          {{ 'DATA_TABLE.TELEPHONE' | translate }}
          <span class="text-danger">*</span>
        </label>
        <input
          type="tel"
          class="form-control"
          id="tel"
          formControlName="tel"
          [class.is-invalid]="isFieldInvalid('tel')"
          [placeholder]="'DATA_TABLE.TELEPHONE' | translate"
        />
        <div class="invalid-feedback" *ngIf="isFieldInvalid('tel')">
          {{ getErrorMessage('tel') }}
        </div>
      </div>
    -->
    </div>

    <div class="row">
      <!-- Grade -->
      <div class="col-md-6 mb-3">
        <label for="grade" class="form-label">
          {{ 'DATA_TABLE.GRADE' | translate }}
          <span class="text-danger">*</span>
        </label>
        <input
          type="text"
          class="form-control"
          id="grade"
          formControlName="grade"
          [class.is-invalid]="isFieldInvalid('grade')"
          [placeholder]="'DATA_TABLE.GRADE' | translate"
        />
        <div class="invalid-feedback" *ngIf="isFieldInvalid('grade')">
          {{ getErrorMessage('grade') }}
        </div>
      </div>

      <!-- Specialization -->
      <div class="col-md-6 mb-3">
        <label for="specialization" class="form-label">
          {{ 'DATA_TABLE.SPECIALIZATION' | translate }}
          <span class="text-danger">*</span>
        </label>
        <input
          type="text"
          class="form-control"
          id="specialization"
          formControlName="specialization"
          [class.is-invalid]="isFieldInvalid('specialization')"
          [placeholder]="'DATA_TABLE.SPECIALIZATION' | translate"
        />
        <div class="invalid-feedback" *ngIf="isFieldInvalid('specialization')">
          {{ getErrorMessage('specialization') }}
        </div>
      </div>
    </div>

    <!-- Professor Image -->
    <div class="row">
      <div class="col-md-12 mb-3">
        <label class="form-label">
          {{ 'ADMIN.PROFESSOR_IMAGE' | translate }}
        </label>
        <div class="d-flex align-items-center gap-3">
          <div *ngIf="imagePreviewUrl" class="position-relative">
            <img [src]="imagePreviewUrl"
                 alt="Professor"
                 class="rounded-circle border"
                 style="width: 80px; height: 80px; object-fit: cover;" />
            <button type="button"
                    class="btn btn-sm btn-danger position-absolute top-0 end-0 rounded-circle p-0"
                    style="width: 20px; height: 20px; font-size: 10px; line-height: 1;"
                    (click)="removeImage()">
              <i class="fa-solid fa-times"></i>
            </button>
          </div>
          <div *ngIf="!imagePreviewUrl" class="rounded-circle border bg-light d-flex align-items-center justify-content-center"
               style="width: 80px; height: 80px;">
            <i class="fa-solid fa-user text-muted" style="font-size: 2rem;"></i>
          </div>
          <div>
            <label class="btn btn-outline-secondary btn-sm" [class.disabled]="isUploadingImage">
              <i class="fa-solid fa-upload me-1"></i>
              {{ (imagePreviewUrl ? 'COMMON.CHANGE' : 'COMMON.UPLOAD') | translate }}
              <input type="file" accept="image/*" class="d-none" (change)="onImageSelected($event)" />
            </label>
            <div *ngIf="isUploadingImage" class="text-muted small mt-1">
              <i class="fa-solid fa-spinner fa-spin me-1"></i>
              {{ 'COMMON.UPLOADING' | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Is Active -->
    <div class="row">
      <div class="col-md-12 mb-3">
        <label class="form-label d-block">
          {{ 'ADMIN.STATUS' | translate }}
        </label>
        <div class="form-check form-switch mt-2">
          <input
            class="form-check-input"
            type="checkbox"
            role="switch"
            id="isActive"
            formControlName="isActive"
          />
          <label class="form-check-label" for="isActive">
            {{ (isActive?.value ? 'ADMIN.ACTIVE' : 'ADMIN.INACTIVE') | translate }}
          </label>
        </div>
      </div>
    </div>

    <!-- Le compte d'accès se crée dans un second temps, depuis la liste -->
    <div *ngIf="!isEditMode" class="alert alert-info d-flex align-items-start gap-2 py-2 px-3 mb-0">
      <i class="fa-solid fa-circle-info mt-1"></i>
      <span class="small">{{ 'ADMIN.ACCOUNT_CREATED_SEPARATELY' | translate }}</span>
    </div>

    <!-- Form Actions -->
    <div class="d-flex justify-content-end gap-2 mt-4 pt-3 border-top">
      <button type="button" class="btn btn-secondary px-4" (click)="onCancel()">
        {{ 'COMMON.CANCEL' | translate }}
      </button>
      <button type="submit" class="btn btn-primary px-4"
        [disabled]="professorForm.invalid || isLoadingAssignments || assignmentsLoadFailed">
        <i class="fa-solid fa-floppy-disk me-2"></i>
        {{ (isEditMode ? 'COMMON.UPDATE' : 'COMMON.SAVE') | translate }}
      </button>
    </div>
  </form>
</div>
